"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
class Client {
    constructor(values) {
        Object.assign(this, values);
    }
    onCompleteDevice(deviceList) {
        return deviceList.find((d) => d.id === this.onComplete);
    }
    onFailDevice(deviceList) {
        return deviceList.find((d) => d.id === this.onFail);
    }
    onNoAnswerDevice(deviceList) {
        return deviceList.find((d) => d.id === this.onNoAnswer);
    }
    onBusyDevice(deviceList) {
        return deviceList.find((d) => d.id === this.onBusy);
    }
}
exports.Client = Client;
